module.exports = __webpack_public_path__ + "f41ad5ec044891927fb21b7dab279bd9.pdf";